<div class="c-card g--margin-t-15">
    <div class="c-card__body g--margin-b-30">

        <!-- Grupo preferencias Alojamientos -->
        <ng-container *ngFor="let preferencia of preferencias">
            <div class="g--margin-t-30"
              *ngIf="preferencia.TipoProducto === ETipoProducto.Hotel && preferencia.Visible && preferencia.Opciones !== null">
                <app-grupo-preferencia
                    #Grupo_Preferencia_Alojamiento
                    [Id]="preferencia.Id"
                    [TituloGrupo]="preferencia.ClaveTraduccion"
                    [ListaPreferencias] = "preferencia.Opciones"
                    [multiple]="preferencia.SeleccionMultiple"
                    [required]="preferencia.Obligatorio"
                    [listaOtros]="listaOtros"> 
                </app-grupo-preferencia>
            </div>
        </ng-container>

        <!-- Grupo Alojamiento Cadenas con Observaciones-->
        <div class="g--margin-t-30 ">
            <div class="g--margin-t-30 c-section-altnative c-table c-table--scroll">
                <div class="c-section-alternative__header">
                    <b>{{"precliente.formulario.hotel.cadenashoteleras" | translate}}</b>
                </div>

                <div class="c-section__body g--margin-t-40">
                    <app-select-search-material
                        #Grupo_Preferencia_Alojamiento_Cadenas
                        [required]="false"
                        [buscador]="true"
                        [multiple]="true"
                        [opciones]="Companias"
                        id="CadenasHoteleras"
                        clase="form-control form-control-md g--margin-b-24"
                        claseIcono=""
                        label="{{'admin.comun.buscar' | translate }}"
                        placeholderBuscador="{{'admin.comun.buscar' | translate }}"
                        placeholderSelector="{{'admin.comun.buscar' | translate }}"
                        (opcionSeleccionadaEvent)="seleccionarOpcionOtroAlojamiento($event)"
                    >
                    </app-select-search-material>

                    <!-- Observaciones -->
                    <div class="g--margin-t-30">
                        <app-observaciones
                            [hidden]="!isOtro"
                            #Grupo_Preferencia_Alojamiento_Cadenas_Observacion
                            [(textareaValue)] = "texto"
                            (textareaValueChange)="actualizarValorObservacion($event)"
                        ></app-observaciones>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
